(function () {
  "use strict";

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initCarousel(root) {
    var inner = qs(".tvg-cc__inner", root);
    var track = qs(".tvg-cc__track", root);
    var items = qsa(".tvg-cc__item", root);
    var spacerStart = qs(".tvg-cc__spacer--start", root);

    if (!inner || !track || !items.length) return;

    track.style.webkitOverflowScrolling = "touch";
    track.style.overflowX = "auto";

    function gap() {
      var s = window.getComputedStyle(track);
      var g = parseFloat(s.gap || s.columnGap || 16);
      return isNaN(g) ? 16 : g;
    }
    function startOffset() {
      var w = spacerStart ? spacerStart.getBoundingClientRect().width : 0;
      return w + gap();
    }
    function clamp(v, min, max) { return Math.min(Math.max(v, min), max); }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function snapStart() {
      var left = clamp(startOffset(), 0, maxScroll());
      track.scrollLeft = left;
    }

    var isDown = false;
    var startX = 0;
    var startLeft = 0;
    var dragged = false;
    var enabled = false;

    function onClickCapture(e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }
    function onMouseDown(e) {
      isDown = true;
      dragged = false;
      track.classList.add("is-dragging");
      startX = e.clientX;
      startLeft = track.scrollLeft;
    }
    function onMouseMove(e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 2) {
        e.preventDefault();
        dragged = true;
      }
      track.scrollLeft = startLeft - dx;
    }
    function onMouseUp() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove("is-dragging");
    }

    function addDesktopHandlers() {
      if (enabled) return;
      enabled = true;
      track.addEventListener("click", onClickCapture, true);
      track.addEventListener("mousedown", onMouseDown);
      window.addEventListener("mousemove", onMouseMove, { passive: false });
      window.addEventListener("mouseup", onMouseUp);
      snapStart();
    }
    function removeDesktopHandlers() {
      if (!enabled) return;
      enabled = false;
      track.removeEventListener("click", onClickCapture, true);
      track.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mousemove", onMouseMove, { passive: false });
      window.removeEventListener("mouseup", onMouseUp);
      track.classList.remove("is-dragging");
      isDown = false;
      dragged = false;
    }

    var mqDesktop = window.matchMedia("(min-width: 1024px)");
    var mqFine    = window.matchMedia("(pointer: fine)");

    function reevaluate() {
      if (mqDesktop.matches && mqFine.matches) {
        addDesktopHandlers();
      } else {
        removeDesktopHandlers();
      }
    }

    reevaluate();
    if (mqDesktop.addEventListener) {
      mqDesktop.addEventListener("change", reevaluate);
      mqFine.addEventListener("change", reevaluate);
    } else {
      mqDesktop.addListener(reevaluate);
      mqFine.addListener(reevaluate);
    }

    var rAF = 0;
    function onResize() {
      if (rAF) cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(function () {
        if (enabled) snapStart();
      });
    }
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
  }

  document.addEventListener("DOMContentLoaded", function () {
    qsa(".tvg-cc").forEach(initCarousel);
  });
})();
